// You can customize the template with the help of this file

//Template config options
const themeConfig = {
  app: {
    appName: '',
    appLogoImage: require('@src/assets/images/logo/logo-dark.png').default,
    appFavivonImage: require('@src/assets/images/logo/favicon-dark.svg').default,
    appLightLogoImage: require('@src/assets/images/logo/logo-light.png').default,
    appLightFavivonImage: require('@src/assets/images/logo/favicon-light.svg').default
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  }
}
// if (localStorage.getItem('menuCollapsed') === 'true') {
//   themeConfig.app.appLogoImage = require('@src/assets/images/logo/favicon-light.png').default
// }
export default themeConfig
